import React from "react";
import "../styles/Policies.css";
import { Link } from "react-router-dom";

function Terms() {
  return (
    <div>
      <div className="Conditions-terms">
        <div className="breadcrumb">
          <Link to="/">Home</Link> /{" "}
          <Link to="/Terms-and-Conditions">Terms and Conditions</Link>
        </div>
        <h1 className="Condition">Terms and Conditions</h1>
        <div className="content">
          <p>
            1. All information, products and services displayed on the
            www.@example.com website constitute an “invitation to offer”. Your
            order for purchase constitutes your “offer” which shall be subject
            to the terms and conditions as listed below. Sankalp Ayurveda website
            has the right to accept or reject your offer without assigning any
            reason thereof. In order to use the www.@example.com website
            belonging to Sankalpveda Natural Pvt. Ltd., you (The User) have
            accepted the following terms and conditions given below. Sankalp
            Ayurveda reserves the right to add, delete, alter or modify these
            terms and conditions at any time. You (The User) are therefore
            advised to read carefully these terms and conditions every time you
            use the www.@example.com website of Sankalpveda Natural Pvt. Ltd.
          </p>
          <p>
            2. We have made every effort to display the colour of our products
            that appear on the site as accurately as possible. However, as the
            actual colours you see will depend on your monitor, we cannot
            guarantee that your monitor’s display of colour will be accurate.
          </p>
          <p>
            3. The User certifies that he/she is at least 18 (eighteen) years of
            age or has the consent of a parent or legal guardian.
          </p>
          <p>
            4. All products are subject only to any applicable warranties of
            their respective manufacturers, distributors, and suppliers, if any,
            provided in the product packaging. To the fullest extent permissible
            by applicable law, we hereby disclaim all warranties of any kind,
            either express or implied, including without limitation, any implied
            warranties of merchantability, non-infringement, or fitness for a
            particular purpose. Without limiting the generality of the
            foregoing, we hereby expressly disclaim all liability for product
            defect, any damage suffered by users from use of the services on
            this website, or failure claims that are due to normal use, product
            misuse, abuse, product modification, improper product selection,
            non-compliance with any codes, or misappropriation of any kind.
            Sankalp Ayurveda will not be liable to you or any third party for any
            consequential, incidental, indirect, punitive or special damages
            (including, without limitation, damages relating to lost profits,
            lost data or loss of goodwill) arising out of, relating to or
            connected with the use of the website or products, regardless of the
            cause of action on which they are based, even if advised of the
            possibility of such damages occurring.
          </p>
          <p>
            5. Sankalp Ayurveda will take responsibility of your Order, if the
            Order has been shipped to any of the major cities (metros), where we
            use “Private Courier Companies” (eg. ATS, Blue Dart, First Flight,
            Fedex, Delhivery etc.) to ship your order.
          </p>
          <p>
            6. The prices and availability of products are subject to change
            without prior notice at the sole discretion of Sankalp Ayurveda.
          </p>
          <p>
            7. Sankalp Ayurveda reserves the right to refuse or cancel any order
            placed for a product that is listed at an incorrect price or for any
            other reason. This shall be regardless of whether the order has been
            confirmed and/or payment been received. The payment shall be
            refunded and the User shall be informed of the same.
          </p>

          <p>
            8. If a non-delivery or late delivery occurs due to a mistake by the
            User (i.e. wrong or incomplete name or address or recipient not
            available) any extra cost spent by Sankalp Ayurveda for re-delivery
            shall be claimed from the User placing the order.
          </p>
          <p>
            9. The User agrees to give accurate, authentic and true information.
            Sankalp Ayurveda reserves the right to confirm and validate the
            information and other details provided by the User at any point of
            time. If any such User details are found not to be true wholly or
            partly, Sankalp Ayurveda has the right in its sole discretion to
            reject the registration and debar the User from using the services
            of www.@example.com without prior intimation whatsoever.
          </p>
          <p>
            10. Sankalp Ayurveda will not be liable for any type or kind of
            credit card fraud. The liability to use a card fraudulently will be
            on the user and the onus to ‘prove otherwise’ shall be exclusively
            on the user. The User must exclusively use his/her own card on the
            site.
          </p>
          <p>
            11. Sankalp Ayurveda shall not entertain any complaints after 15 days
            of order delivery.
          </p>

          <p>
            12. This agreement shall be construed in accordance with the
            applicable laws of India. The Courts of India shall have exclusive
            jurisdiction in any proceedings arising out of this agreement.
          </p>
          <h2 className="coupon">COUPON TERMS & CONDITIONS </h2>
          <p>
            1. Coupons are valid for a limited time only. Sankalp Ayurveda
            reserves the right to modify or cancel coupons at any time.
          </p>
          <p>
            2. The coupon offer will not be valid until it is applied to the
            qualifying item.{" "}
          </p>
          <p>
            3. The coupon may only be used on www.@example.com and in
            conjunction with the purchase of products shipped and sold
            bywww.@example.com . The coupon is not valid on products sold by
            third-party sellers or other e-commerce websites.
          </p>
          <p>4. The coupon is limited to one coupon per customer.</p>
          <p>
            5. If you return any of the items purchased with a coupon, the
            coupon discount or value may be subtracted from the return
            credit.{" "}
          </p>
          <p>
            6. Applicable shipping and handling charges apply to all products as
            per the Shipping & Returns Policy.
          </p>
          <p>7. Offer good while supplies last.</p>
          <p>8. Void where prohibited.</p>
          <p>
            9. Sankalp Ayurveda has no obligation for payment of any tax in
            conjunction with the distribution or use of any coupon.
          </p>
          <p>
            10. Consumer is required to pay any applicable taxes related to the
            use of the coupon.
          </p>
          <p>11. Coupons are void if restricted or prohibited by law.</p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
